import SearchOffOutlinedIcon from '@mui/icons-material/SearchOffOutlined';
import { Box, Button, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

type ResourceNotFoundProps = {
    resourceLabel: string;
    listPath: string;
    listLabel: string;
};

export function ResourceNotFound({
    resourceLabel,
    listPath,
    listLabel,
}: ResourceNotFoundProps) {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                minHeight: '40vh',
                px: 2,
                py: 6,
                gap: 1.5,
            }}
        >
            <SearchOffOutlinedIcon
                sx={{ fontSize: 40, color: 'text.disabled', mb: 0.5 }}
            />
            <Typography variant="h5" fontWeight={600} color="text.primary">
                {resourceLabel} not found
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 360 }}>
                This {resourceLabel.toLowerCase()} does not exist or you do not have
                access to it.
            </Typography>
            <Button
                component={Link}
                to={listPath}
                variant="outlined"
                size="small"
                sx={{ mt: 1, textTransform: 'none' }}
            >
                {listLabel}
            </Button>
        </Box>
    );
}
